module.exports = __webpack_public_path__ + "static/img/11_1Intro_3_Kaprow_RoutineProgram_p4_Detail_FPO.6011400.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/kaprow/images/11_1Intro_3_Kaprow_RoutineProgram_p4_Detail_FPO.jpg
// module id = pzJs
// module chunks = 0